/**
 * --------------------------------------------------------------------------
 * Bootstrap index.umd.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

import * as Helpers from "./src/util/index.js";

import SelectorEngine from "./src/dom/selector-engine.js";
import EventHandler from "./src/dom/event-handler.js";
import Manipulator from "./src/dom/manipulator.js";

import Alert from "./src/alert.js";
import Button from "./src/button.js";
import Carousel from "./src/carousel.js";
import Collapse from "./src/collapse.js";
import Dropdown from "./src/dropdown.js";
import Modal from "./src/modal.js";
import Offcanvas from "./src/offcanvas.js";
import Popover from "./src/popover.js";
import ScrollSpy from "./src/scrollspy.js";
import Tab from "./src/tab.js";
import Toast from "./src/toast.js";
import Tooltip from "./src/tooltip.js";

// Custom functions
import RevealScrollSpy from "./src/customs/RevealScrollSpy.js";
import NotificationToast from "./src/customs/NotificationsToast.js";
import MultiItemCarousel from "./src/customs/MultipleItemsCarousel.js";
import ExtendedSwipe from "./src/customs/SwipeExtended.js";

export default {
	...Helpers,
	SelectorEngine,
	EventHandler,
	Manipulator,
	Alert,
	Button,
	Carousel,
	Collapse,
	Dropdown,
	Modal,
	Offcanvas,
	Popover,
	ScrollSpy,
	Tab,
	Toast,
	Tooltip,
	RevealScrollSpy,
	NotificationToast,
	MultiItemCarousel,
	ExtendedSwipe,
};
